<template>
  <LayoutGradient :title="pageTitle" icon="fa-file-signature">
    <template v-slot:headerRight>
      <b-btn variant="outline-info" @click="$router.back()">
        <i class="fas fa-arrow-left"/> {{ $t('sideBar.voltar') }}
      </b-btn>
    </template>
    <b-card class="m-3 mt-n10">
      <b-form @submit="onSubmit">
        <b-form-group :label="$t('states.form.fields.nome.label')" label-for="input-name">
          <b-form-input id="input-name" v-model="state.name" type="text"/>
        </b-form-group>
        <b-form-group
            :label="$t('states.form.fields.status.label')"
            label-for="input-status"
            :description="$t('states.form.fields.status.description')"
        >
          <b-form-checkbox id="input-status" v-model="state.status" size="lg" switch/>
        </b-form-group>
        <b-button type="submit" variant="success">
          <i class="fas fa-save"/> {{ $t('states.form.fields.botao_salvar') }}
        </b-button>
      </b-form>
    </b-card>
  </LayoutGradient>
</template>

<script>
import LayoutGradient from "@/templates/LayoutGradient";
import StatesRepository from '@/repositories/vns/StateRepository'
import {mapActions, mapGetters} from "vuex";

export default {
  name: "Form",
  components: {
    LayoutGradient
  },
  data() {
    return {
      state_id: null
    }
  },
  computed: {
    ...mapGetters({
      state: 'states/current',
      isLoading: 'states/isLoading'
    }),
    pageTitle() {
      if (this.state_id) return this.$t('states.form.titulo_pagina.editar')
      return this.$t('states.form.titulo_pagina.criar')
    }
  },
  methods: {
    ...mapActions([
      'states/listOne'
    ]),
    async onSubmit(evt) {
      evt.preventDefault()
      if (this.$route.params.id) {
        this.update()
      } else {
        this.create()
      }
    },
    create() {
      StatesRepository.post(this.state).then(() => {
        this.$snotify.success(this.$t('states.form.create.success'))
        this.$router.push({name: 'vns.states'})
      }).catch(error => {
        this.$snotify.error(this.$t('states.form.create.error'))
        if (error.response.status === 422) {
          StatesRepository.toastValidationErrors(error, this.$snotify)
        }
      })
    },
    update() {
      StatesRepository.put(this.state_id, this.state).then(() => {
        this.$snotify.success(this.$t('states.form.update.success'))
        this.$router.push({name: 'vns.states'})
      }).catch(error => {
        this.$snotify.error(this.$t('states.form.update.error'))
        if (error.response.status === 422) {
          StatesRepository.toastValidationErrors(error, this.$snotify)
        }
      })
    }
  },
  async mounted() {
    this.$store.commit('states/setCurrent', {status: false})
    if (this.$route.params.id) {
      this.state_id = this.$route.params.id
      await this['states/listOne'](this.$route.params.id)
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
